import * as events from './event-bus';
import * as env from './env';
import * as store from './store';

import {
	getWithCredentials
} from './idm-helpers';
import { loadPermissionBaseUrl } from './baseurl-helper';

// Checks to see whether a user has visibility to themselves or themselves and others
export function checkViewOthersPermission(idmData) {
    const notIdm = store.get('idm') === null;
    const cfg = notIdm ? store.get('passport') : store.get('idm');
    let envName = env.environmentFromIdmGatewayUrl(cfg.idGatewayUrl);
	if (cfg.product === 'FCQA') { envName = 'qa'; }
    const envValues = env[envName];
    const { ecSand } = envValues;
    let permissionBaseUrl = notIdm ? loadPermissionBaseUrl() : `${ecSand}/PermissionAPI/api`;
    const idmAdministrator = idmData.roles.includes('IdmAdministrator');

    let employee = null;
    if (idmData.identities){
		employee = idmData.identities.find(x => x.Type === 'employee' || x.Type === 'EmployeeQA');
    }

    if (employee) {
        getWithCredentials(`${permissionBaseUrl}/NumVisibleContextIds/${idmData.userContext.OrganizationId}/Employee?objectName=Employee&actionName=View`, function (res) {
            // if this response is greater than 1 the user can see others (in which case we'll show "Employee Directory" rather than "My Profile")
            const viewOthers = res > 1 ? true : false;
            events.emit('view-others-permissions-checked', viewOthers );
        }, [{key: 'fluser', value: JSON.stringify({'UserKey': employee.Id})}]);
    }else if (idmAdministrator) {
        events.emit('view-others-permissions-checked', true );
    } else {
        events.emit('view-others-permissions-checked', false );
    }
}

